import Init from '../../../extendable/Init';
import './Vouchers.scss';

const Vouchers = () => {
	const chooseVoucher = () => {
		const vouchers = [...document.getElementsByClassName('js-voucher-value')];
		const voucherValue = document.querySelector('.js-voucher-value-input');
		
		const onVoucherClickHandler = ({currentTarget}) => {
			console.log('click');
			if (!currentTarget.classList.contains('active')) {
				vouchers.map(voucher => voucher.classList.remove('active'));
				currentTarget.classList.add('active');
				voucherValue.value = currentTarget.dataset.value;
				currentTarget.classList.contains('other') && voucherValue.select();
			}
		};
		
		voucherValue.addEventListener('change', function () {
			voucherValue.value = voucherValue.value.replace(/[^0-9]/g, '');
		});
		
		voucherValue.addEventListener('keypress', function validate(evt) {
			var theEvent = evt || window.event;
			
			// Handle paste
			if (theEvent.type === 'paste') {
				//key = event.clipboardData.getData('text/plain');
				theEvent.returnValue = false;
			} else {
				// Handle key press
				var key = theEvent.keyCode || theEvent.which;
				key = String.fromCharCode(key);
			}
			var regex = /[0-9]|\./;
			if (!regex.test(key)) {
				theEvent.returnValue = false;
				if (theEvent.preventDefault) theEvent.preventDefault();
			}
		});
		
		vouchers.map(voucher =>
			voucher.addEventListener('click', onVoucherClickHandler)
		);
	};
	
	chooseVoucher();
};

Init(Vouchers);
